export function hash(seed, tick, salt) {
    let h = (seed + tick * 31 + salt * 17) | 0;
    h = Math.imul(h ^ (h >>> 16), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    return (h ^ (h >>> 16)) >>> 0;
}
export function randomFloat(seed, tick, salt) {
    return hash(seed, tick, salt) / 4294967296;
}
export function randomInt(seed, tick, salt, min, max) {
    return min + Math.floor(randomFloat(seed, tick, salt) * (max - min));
}
